import React, { useEffect, useState } from 'react';
import TranslatorService from "../../../services/Translator/TranslatorService";

const MaintenanceNotice = () => {
    const [showMessage, setShowMessage] = useState(false);
    
    const maintenanceStart = new Date('2024-11-04');
    const maintenanceEnd = new Date('2024-11-05');

    useEffect(() => {
        const checkMaintenance = () => {
            const today = new Date();

            if (today >= maintenanceStart && today <= maintenanceEnd) {
                setShowMessage(true);
            }

            const twoDaysBeforeMaintenance = new Date(maintenanceStart);
            twoDaysBeforeMaintenance.setDate(maintenanceStart.getDate() - 2);

            if (today.toDateString() === twoDaysBeforeMaintenance.toDateString()) {
                setShowMessage(true);
            }
        };

        checkMaintenance();

        const intervalId = setInterval(checkMaintenance, 60000);
        
        return () => clearInterval(intervalId); 
    }, []);

    const handleClose = () => {
        setShowMessage(false);
    };

    return (
        <>
            {showMessage && (
            <div className="alert alert-warning position-relative" role="alert">
                <button onClick={handleClose} className="btn-close position-absolute top-0 end-0" style={{marginRight: '10px', marginTop: '10px'}} aria-label="Fechar"></button>
                <strong><TranslatorService path="maintenanceAlert.title" /></strong>
                <p>
                    <TranslatorService path="maintenanceAlert.greeting" />,
                    <br /><br />
                    <TranslatorService path="maintenanceAlert.message" />
                    <br />
                    <TranslatorService path="maintenanceAlert.importance" />
                    <br />
                    <TranslatorService path="maintenanceAlert.request" />
                    <br />
                    <TranslatorService path="maintenanceAlert.thankYou" />
                </p>
            </div>
        )}
        </>
    );
};

export default MaintenanceNotice;
